import UpsertNamespaceAdminListRequestItem from '../../../../../projects/performers/i-service/model/namespace-admins/UpsertNamespaceAdminListRequestItem';

/**
 * * Модель запроса на добавление администраторов к рабочей области
 */
export default class UpsertNamespaceAdminListRequest  {
	/**
	 * * Номер рабочей области
	 */
	NamespaceId!: string;
	/**
	 * * Список администраторов
	 */
	AdminList!: Array<UpsertNamespaceAdminListRequestItem>;
	/**
	 * * Удаление администраторов назначенных исполнителями из задач
	 */
	RemoveTaskPerformer: boolean = false;
	/**
	 * * Удаление администраторов назначенных наблюдателями из задач
	 */
	RemoveTaskObserver: boolean = false;
	/**
	 * * Удаление доступов к очередям
	 */
	RemoveQueueTasksAccess: boolean = false;
	constructor(obj?: Partial<UpsertNamespaceAdminListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
